import React from 'react';

import { FieldProps } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/components/Field';
import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const NonControlledField = ({ subFieldName, as: Component, placeholder, label, ...rest }: FieldProps) => {
  const { fieldNamesPrefix, mode } = useAddressContext();

  const name = `${fieldNamesPrefix}.${subFieldName}`;

  return React.cloneElement(Component, {
    name,
    label,
    ...(mode === AddressMode.MANUAL && { placeholder }),
    fieldVariant: FieldVariant.form,
    ...rest,
  });
};
